var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVersionInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.95801V11.333",
    stroke: "#0A3F73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0675 7.65035V13.3503C18.0675 14.2837 17.5675 15.1504 16.7591 15.6254L11.8091 18.4837C11.0008 18.9504 10.0008 18.9504 9.18412 18.4837L4.23412 15.6254C3.42579 15.1587 2.92578 14.292 2.92578 13.3503V7.65035C2.92578 6.71702 3.42579 5.85032 4.23412 5.37532L9.18412 2.51699C9.99246 2.05033 10.9925 2.05033 11.8091 2.51699L16.7591 5.37532C17.5675 5.85032 18.0675 6.70869 18.0675 7.65035Z",
    stroke: "#0A3F73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14V14.0833",
    stroke: "#0A3F73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionInfoIcon);
export default __webpack_public_path__ + "static/media/version_info_icon.cdf9a015bc947e47c244e000f70cfe5e.svg";
export { ForwardRef as ReactComponent };